import React from 'react';
import Link from "componentsTemplate/Link";
import NcImage from "componentsTemplate/NcImage/NcImage";
import image2 from "assets/images/sliders/IMAGEM_02.jpg"
import { BsTools } from "@react-icons/all-files/bs/BsTools";


const ComingSoonPage: React.FC = () => {
  return (
    <div className="nc-PageHome relative mt-16">
      <div className="container relative">
        <div className={`nc-SectionLargeSlider relative`}>
          <div className={`nc-CardLarge1 nc-CardLarge1--hasAnimation relative flex flex-col-reverse md:flex-row justify-end `}>
            <div className="md:absolute z-10 md:left-0 md:top-1/2 md:-translate-y-1/2 w-full -mt-8 md:mt-0 px-3 sm:px-6 md:px-0 md:w-3/5 lg:w-1/2 xl:w-2/5">
              <div className="nc-CardLarge1__left p-4 sm:p-8 xl:py-10 md:px-10 bg-white/40 dark:bg-neutral-900/40 backdrop-filter backdrop-blur-lg shadow-lg dark:shadow-2xl rounded-3xl space-y-3 sm:space-y-5 ">
                <BsTools className="text-primary-6000" size={50} />
                <h2 className=" text-4xl sm:text-5xl lg:text-6xl font-semibold ">
                    Em breve ...
                </h2>
                <span className="mt-2 md:mt-3 font-normal block text-base sm:text-2xl text-primary-500 dark:text-primary-400">
                  O maior site de conexões para mulheres do Brasil!
                </span>
                <br /> 
              </div>
            </div>
            <div className="w-full md:w-4/5 lg:w-2/3">
              <NcImage
                containerClassName="aspect-w-16 aspect-h-12 sm:aspect-h-9 md:aspect-h-14 lg:aspect-h-10 2xl:aspect-h-9 relative"
                className="absolute inset-0 object-cover rounded-3xl"
                src={image2}
                alt={'title'}
                fill
                sizes="(max-width: 768px) 100vw, 50vw"
              />

            <br />
            <br />
            </div>
          </div>
        </div>
      </div>
  </div>
  );
};

export default ComingSoonPage;

